// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610142150/js/" + chunkId + "." + {"44":"91fc858d","225":"83d7fa1d","481":"a33a7787","486":"dca095ee","770":"fa37ffef"}[chunkId] + ".0.5766892763540967.chunk.js";
};